import { afterNextRender, Component, inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-general-terms-page',
  template: ``,
  standalone: false,
})
export class GeneralTermsPageComponent {
  platformId = inject(PLATFORM_ID);
  constructor() {
    afterNextRender(() => {
      window.location.href = `${environment.appUrl}/assets/documents/Conditions_générales.pdf`;
    });
  }
}
